export const ANALYTICS_RATING_RESULTS_LIMIT = 10
export const DASHBOARD_TAB_QUERY_KEY = 'tab'
